import { render, staticRenderFns } from "./MemberListLink.vue?vue&type=template&id=ab41a5b0&scoped=true"
import script from "./MemberListLink.vue?vue&type=script&lang=js"
export * from "./MemberListLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab41a5b0",
  null
  
)

export default component.exports